//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import { Field } from 'react-final-form'

import RichTextEditor from 'components/Shared/RichTextEditor/Index'
import { customIsEqual } from './utils'

const FieldComponent = ({
  value,
  onChange,
  isReadOnly,
  placeholder,
  minRows,
}) => {
  return (
    <RichTextEditor
      value={value}
      onChange={onChange}
      isReadOnly={isReadOnly}
      placeholder={placeholder}
      minRows={minRows}
    />
  )
}

FieldComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  isReadOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  minRows: PropTypes.number,
}

const RichTextField = ({ name, validate, isReadOnly, placeholder, minRows }) => {
  return (
    // without custom parse empty values are not passed to onSubmit() so API doesn't get cleared strings
    // see https://github.com/final-form/react-final-form/issues/130#issuecomment-425482365
    <Field
      name={name}
      isEqual={customIsEqual}
      validate={validate}
      parse={value => (value)}
    >
      {({ input, meta }) => {
        return (
          <FieldComponent
            value={input.value}
            onChange={input.onChange}
            isReadOnly={isReadOnly}
            placeholder={placeholder}
            minRows={minRows}
          />
        )
      }}
    </Field>
  )
}

RichTextField.propTypes = {
  name: PropTypes.string,
  validate: PropTypes.func,
  isReadOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  minRows: PropTypes.number,
}

export default RichTextField
